import { config, type SupportedCountry } from "@config";

export function isSupportedCountry(
  countryCode: string,
): countryCode is SupportedCountry {
  const normalizedCountryCode = countryCode.toLowerCase().trim();
  return config.supportedCountries.includes(normalizedCountryCode as SupportedCountry);
}

export function assertSupportedCountry(countryCode: string): SupportedCountry {
  if (!isSupportedCountry(countryCode)) {
    throw new Error(`Unsupported country: ${countryCode}`);
  }

  return countryCode;
}
